import React, { Component, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import history from '../../../route/history'
import { regisActions, alertActions } from '../../../store/actions'
import KTnetModal2 from '../../../module/ktnet/KTnetModal2'
import KTnetModalExport from '../../../module/ktnet/KTnetModalExport'
import KTnetModalImport from '../../../module/ktnet/KTnetModalImport'
import Input from '../../../module/input'
import moment from 'moment'
import Alert from '../../../module/alert/Alert'
import { valid } from '../../../hook/valid'

const CrtfctStepMobile02 = (props) => {
  console.log('get props', props)
  console.log('get Info', props.location.state.selectedInfo)
  const [state, setState] = useState({
    isView: false,
    certCode: '',
    rtnCode: '',
    password: '',
    crtfctSuccess2: false,
    num1: '',
    num2: '',
    num3: '',
  })

  const [certChkInfo, setCertChkInfo] = useState({
    signCompleted: false,
    certChkYn: 'Y',
  })

  const handleChange = (e) => {
    const { value, name } = e.target // 우선 e.target 에서 name 과 value 를 추출
    setState({
      ...state, // 기존의 input 객체를 복사한 뒤
      [name]: value, // name 키를 가진 값을 value 로 설정
    })
  }

  function crtfctExport() {
    var subjectDn = document.getElementById('subjectDn').value
    var code = state.num1 + state.num2 + state.num3
    //console.log("2 subjectDn",subjectDn)
    //console.log("2 password",state.password)
    //console.log("2 code", code)
    window.M.execute(
      'exWNSendCert',
      subjectDn,
      state.password,
      code,
      window.M.response
        .on(function (status, result) {
          //console.log(status);
          //console.log(JSON.stringify(result));
          //window.M.pop.alert('status : ' + status + ', result : ' + JSON.stringify(result));
          //window.M.pop.alert('인증서 내보내기 성공');
          crtfctExportComplete()
        })
        .toString(),
    )
  }

  function crtfctExportConfirm() {
    //var subjectDn = 'cn=테스트(KTNET),ou=KTNET,ou=LicensedCA,o=TradeSign,c=KR';
    var subjectDn = document.getElementById('subjectDn').value
    console.log('1 subjectDn', subjectDn)
    // 인증서 비밀번호 평문 로그 제거 (프로덕션 빌드에도 console.log 가 남아 F12 로 노출됨)
    //console.log("1 subjectDn",subjectDn)
    //console.log("1 password",state.password)
    window.M.execute(
      'exWNVerifyCertPassword',
      subjectDn,
      state.password,
      window.M.response
        .on(function (status, result) {
          console.log(status)
          console.log(JSON.stringify(result))
          //window.M.pop.alert('status : ' + status + ', result : ' + JSON.stringify(result));
          if (status === 'SUCCESS') {
            //window.M.pop.alert('성공');
            setState({ ...state, crtfctSuccess2: true })
          }
        })
        .toString(),
    )
  }
  /**
   * 네이티브 화면 메시지 처리
   */
  const crtfctExportComplete = () => {
    props.success({
      title: '확인',
      message: '인증서 내보내기를 완료했습니다.',
      params: {
        type: 'SUCCESS',
        callback: () => {
          //return
          window.location.href = '/crtfct/mngMobile'
        },
      },
    })
  }

  const prePage = (e) => {
    e.preventDefault()
    history.goBack()
  }

  return (
    <React.Fragment>
      {/* <!-- contents --> */}
      <div id="contents">
        <div className="content-header">
          <a href="#" className="page-prev" onClick={prePage}>
            뒤로이동
          </a>
          {/* <!-- mobile --> */}
          <h2>공동인증서 관리</h2>
          <div className="breadcrumb">
            <span>Home</span>
            <span>마이페이지</span>
            <em>공동인증서 내보내기</em>
          </div>
        </div>
        {!state.crtfctSuccess2 ? (
          <div className="certify-wrap">
            <ul className="certify-list">
              <li>
                <a>
                  <div className="box">
                    <div className="img"></div>
                    <div className="info">
                      <dl>
                        <dt>{props.location.state.selectedInfo.subjectDn.split('=')[1].split('(')[0]}</dt>
                        <dd>{props.location.state.selectedInfo.issuerDn.split('=')[3].split(',')[0]}</dd>
                        <dd>만료일 : {moment(props.location.state.selectedInfo.notAfter).format('YYYY.MM.DD')}</dd>
                      </dl>
                    </div>
                  </div>
                </a>
              </li>
            </ul>
            <div className="certify-password">
              <p className="tit">인증서 비밀번호를 입력하세요.</p>
              <input
                type="password"
                className="form-keyword"
                title={'비밀번호 입력'}
                id="password"
                name="password"
                value={state.password}
                onChange={(e) => handleChange(e)}
              />
            </div>
            <div className="btn-block center mt140">
              <a className="btn-primary lg w200" onClick={crtfctExportConfirm}>
                확인
              </a>
            </div>
          </div>
        ) : (
          <div className="certify-wrap">
            <div className="certify-code">
              <p className="tit">인증코드 입력</p>
              <div className="code">
                <input
                  type="text"
                  className="form-keyword"
                  title={'인증코드1'}
                  id="num1"
                  name="num1"
                  value={state.num1}
                  maxLength={4}
                  onChange={(e) => handleChange(e)}
                />
                <span className="split">-</span>
                <input
                  type="text"
                  className="form-keyword"
                  title={'인증코드2'}
                  id="num2"
                  name="num2"
                  value={state.num2}
                  maxLength={4}
                  onChange={(e) => handleChange(e)}
                />
                <span className="split">-</span>
                <input
                  type="text"
                  className="form-keyword"
                  title={'인증코드3'}
                  id="num3"
                  name="num3"
                  value={state.num3}
                  maxLength={5}
                  onChange={(e) => handleChange(e)}
                />
              </div>
            </div>
            <h3 className="h3-tit line">인증서 내보내기 방법</h3>
            <ol className="olist1 mt10">
              <li>
                <span>1</span>[PC] [PC] 홈페이지 접속
              </li>
              <li>
                <span>2</span>[PC] ‘마이페이지 &gt; 인증서 관리 &gt; 인증서 가져오기’ 클릭
              </li>
              <li>
                <span>3</span>[PC] 인증코드 확인
              </li>
              <li>
                <span>4</span>[모바일 기기] 인증코드 입력 후
              </li>
              <li>
                <span>5</span>[모바일 기기] 하단의 내보내기 버튼 클릭
              </li>
            </ol>
            <div className="btn-block center mt140">
              <a className="btn-primary lg w200" onClick={crtfctExport}>
                내보내기
              </a>
            </div>
          </div>
        )}
        <input type="hidden" id="subjectDn" name="subjectDn" value={props.location.state.selectedInfo.subjectDn} />
      </div>
      {/* <!-- //contents --> */}
      {/* <Alert /> */}
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    checkedRegNo: state.regis.checkedRegNo,
  }
}

const actionCreators = {
  success: alertActions.success,
  error: alertActions.error,
  checkedRegNo: regisActions.checkedRegNo,
  onCrtfctfInfo: regisActions.onCrtfctfInfo,
  delCrtfctfInfo: regisActions.delCrtfctfInfo,
}

export default connect(mapStateToProps, actionCreators)(CrtfctStepMobile02)
